import styled from 'styled-components';

import type { ReactNode } from 'react';

// Deep link to Settings → AI Voices, the only place voices are activated for a
// workspace. Preserves the `env` query param so local/dev sessions keep their
// environment (the Settings route reads `?tab=` to open the right tab).
export function settingsAiVoicesHref(): string {
  const query = new URLSearchParams({ tab: 'ai-voices' });
  const env = new URLSearchParams(window.location.search).get('env');
  if (env) query.set('env', env);
  return `/settings?${query.toString()}`;
}

interface SettingsAiVoicesLinkProps {
  children?: ReactNode;
}

// Inline text link used by the Manage AI Voices surfaces to point at
// activation. Opens in a new tab so the modal the user is in keeps its context.
const SettingsAiVoicesLink = ({
  children = 'Settings → AI Voices',
}: SettingsAiVoicesLinkProps) => (
  <Link href={settingsAiVoicesHref()} target="_blank" rel="noreferrer">
    {children}
  </Link>
);

export default SettingsAiVoicesLink;

const Link = styled.a`
  color: var(--primary);
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;
